












































































































import {
    Component,
    ComponentStyle,
    ComponentConfig,
    ComponentStyleDefinition,
    InjectComponent,
    Prop,
    ProductRecommendation,
    RecommendationBundles,
    SectionType,
    Vue,
    VueComponent,
    Watch,
    RecommendationBundlesSettingsBuilder,
    FlowStep,
    OrderedCategoryInfo
} from "@zoovu/runner-browser-api";
import {
    ProductButtonConfiguration,
    RecommendationConfiguration,
    TopProductConfiguration
} from "../configuration";
import {minWidthValue} from '../styles/abstract/media-query';
import {Hooper, Slide, Navigation, HooperSettings, HooperData} from '../plugins/hooper/hooper';
import {addAllToCartViaJS, addToCartViaUrl} from "./utils";

type NullableProductRecommendation = ProductRecommendation | null

@Component({components: {Hooper, Slide, Navigation}})
export default class AdviceBundleView extends Vue {
    itemsToShow = 1;

    bundlePage = 0;

    @InjectComponent("TopProductView")
    TopProductView: VueComponent;

    @InjectComponent("ProductRecommendationView")
    productRecommendationView!: VueComponent;

    @InjectComponent("FilterPanelView")
    filterPanelView: VueComponent;

    @ComponentStyle()
    componentStyle!: ComponentStyleDefinition;

    @ComponentConfig(RecommendationConfiguration)
    configuration!: RecommendationConfiguration;

    @ComponentConfig(TopProductConfiguration)
    topProductConfiguration!: TopProductConfiguration;

    @ComponentConfig(ProductButtonConfiguration)
    productButtonConfiguration!: ProductButtonConfiguration;

    @Prop()
    advice!: RecommendationBundles;

    @Prop()
    sectionType!: SectionType;

    @Prop()
    filters: FlowStep[];

    get currentPageBundles(): ReadonlyArray<ReadonlyArray<NullableProductRecommendation>> {
        return this.advice.currentPage.productsBundles.map(bundle => {
            const mappedBundle = bundle.map((product, index) => {
                const categoryInfo = this.orderedCategoryInfos[index];
                return {...product, categoryInfo};
            })
            return mappedBundle;
        });
    }

    get carouselSettings(): HooperSettings {
        return {
            itemsToShow: 1,
            trimWhiteSpace: true,
            wheelControl: false,
            breakpoints: {
                [minWidthValue.sm]: {
                    itemsToShow: 2,
                },
                [minWidthValue.md]: {
                    itemsToShow: 4,
                },
            }
        };
    }

    get showAddAllToCartButton (): boolean {
        return Boolean(this.productButtonConfiguration.showAddAllToCartButton?.enabled);
    }

    get withFilters(): Record<string, unknown> {
        return {
            'with-filters': this.canRenderFilters,
        };
    }

    get canRenderFilters(): boolean {
        return this.filters
            && this.filters.length > 0
            && this.advice.hasProducts
            && this.sectionType === SectionType.RESULTS_PAGE;
    }

    get showOnlyOneBundlePerPage(): boolean {
        return Boolean(this.configuration.showOnlyOneBundlePerPage);
    }

    get orderedCategoryInfos(): ReadonlyArray<OrderedCategoryInfo> {
        return this.advice.currentPage.orderedCategoryInfos;
    }

    @Watch("configuration", {deep: true})
    requestUpdate() {
        this.setVisualSettings();
        this.requestAdviceUpdate(true);
    }

    mounted(): void {
        this.setVisualSettings();
        this.requestAdviceUpdate(true);
        this.$root.$refs.recommendationView = this.$refs.recommendationView;
    }

    showCurrentBundle(bundleIndex: number): boolean {
        return this.showOnlyOneBundlePerPage && bundleIndex === this.bundlePage || !this.showOnlyOneBundlePerPage
    }

    onHooperUpdate(hooperData: HooperData): void {
        this.itemsToShow = hooperData.settings?.itemsToShow ?? 1;
    }

    setVisualSettings(): void {
        const recommendationSettingsBuilder = new RecommendationBundlesSettingsBuilder()
            .withSettingsForSection(SectionType.RESULTS_PAGE, {
                numberOfBundlesPerPage: this.configuration.numberOfBundlesPerPage,
            })
            .withSettingsForSection(SectionType.QUESTIONNAIRE, {
                numberOfBundlesPerPage: 0,
            });

        this.advice.setRecommendationSettings(recommendationSettingsBuilder.build());
    }

    requestAdviceUpdate(shouldRunEvenIfPageIsAlreadyLoaded: boolean): void {
        if (shouldRunEvenIfPageIsAlreadyLoaded || !this.advice.currentPage) {
            this.advice.requestUpdate();
        }
    }

    isValidRecommendation(maybeRecomendation: NullableProductRecommendation): boolean {
        return Boolean(maybeRecomendation && maybeRecomendation.mid)
    }

    getValidBundleProductsCount(bundleProducts: ReadonlyArray<NullableProductRecommendation>): number {
        return bundleProducts.filter(this.isValidRecommendation).length
    }

    addToCart(bundle: ProductRecommendation[]) {
        const filteredBundle = bundle.filter(this.isValidRecommendation);

        switch (this.productButtonConfiguration.showAddAllToCartButton.option) {
            case "javascript":
                const addToCartJavascript = this.productButtonConfiguration.showAddAllToCartButton?.javascript?.code || "";
                addAllToCartViaJS(addToCartJavascript, filteredBundle);
                break;
            case "url":
                const addToCartUrlPropertyName = this.productButtonConfiguration.showAddAllToCartButton?.url?.attribute?.name || "";
                addToCartViaUrl(addToCartUrlPropertyName, false, filteredBundle);
                break;
            default:
                console.log("No 'Add all to cart' action specified");
                break;
        }
    }

    onResetFilters(): void {
        this.$emit("reset-filters");
    }

    nextBundle(): void {
        this.bundlePage += 1;
    }

    prevBundle(): void {
        this.bundlePage -= 1;
    }
}
